import type { RemovableRef } from "@vueuse/core";
import type { ContentCardModel } from "@/models/ContentCard";

export default (
  contentId: string,
  cached: RemovableRef<RecommendSessionStorage>,
  contents: globalThis.Ref<
    {
      id: string;
      bannerImage: string;
      titleTH: string;
    }[],
    | ContentCardModel[]
    | {
        id: string;
        bannerImage: string;
        titleTH: string;
      }[]
  >,
  contentShows: globalThis.Ref<
    {
      id: string;
      bannerImage: string;
      titleTH: string;
    }[],
    | ContentCardModel[]
    | {
        id: string;
        bannerImage: string;
        titleTH: string;
      }[]
  >,
): boolean => {
  let cachedRecommend: RecommendContentSessionStorage;

  const isRefresh = useRefreshDetector();
  if (isRefresh && cached.value?.[contentId]) {
    delete cached.value[contentId];
    return false;
  }

  if (cached.value?.[contentId]) {
    cachedRecommend = cached.value[contentId];
    if (cachedRecommend.contents.length === 0) return true;

    contents.value = cachedRecommend.contents;
    contentShows.value = cachedRecommend.contentShows;
    return true;
  }

  return false;
};
